import React from 'react';

const PageContent = (props) => {
    return <main className="page" aria-label='Page Content'>
        <div className="page__content">{props.children}</div>
    </main>
};

export default PageContent;